// @flow
import { makeStyles } from "@material-ui/styles";
export default makeStyles(() => ({
  root: {
    display: "flex",
    alignItems: "center"
  },
  pointer: { cursor: "pointer" }
}), { index: 1 })